@if (state.config.betsConfig.qualifiers) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Qualifier ({{ state.config.betsConfig.qualifiers.points }})</mat-card-title>
      <mat-card-subtitle>Teams to qualify from stage</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-in-order-qualifires [bettingForm]="state.bettingForm"
                              [dropdowns]="state.qualifiersOptions"
                              [initValue]="state.betting?.qualifiers!"
                              [numOfSelections]="2"
                              key="qualifiers">
      </oo-in-order-qualifires>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.extraQualifiers) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Extra Qualifiers({{ state.config.betsConfig.extraQualifiers.points }})
      </mat-card-title>
      <mat-card-subtitle>Teams that are qualified not from top positions</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.extraQualifiersOptions"
                            [initValue]="state.betting?.extraQualifiers"
                            [key]="'extraQualifiers'"
                            [multi]="true"
                            [numOfSelections]="state.config.numberOfExtraQualifiers!"
                            [multipleDropdowns]="false">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.mostScoringTeam) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Most scoring team ({{ state.config.betsConfig.mostScoringTeam.points }})</mat-card-title>
      <mat-card-subtitle>Team to score most amount of goals in groups stage</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.mostScoringTeamOptions"
                            [initValue]="state.betting?.mostScoringTeam"
                            [key]="'mostScoringTeam'"
                            [multi]="state.isSubmissionMode"
                            [multipleDropdowns]="false">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.leastScoringTeam) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Least scoring team ({{ state.config.betsConfig.leastScoringTeam.points }})</mat-card-title>
      <mat-card-subtitle>Team to score least amount of goals in groups stage</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.leastScoringTeamOptions"
                            [initValue]="state.betting?.leastScoringTeam"
                            [key]="'leastScoringTeam'"
                            [multi]="state.isSubmissionMode"
                            [multipleDropdowns]="false">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.worstTeam) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Worst team ({{ state.config.betsConfig.worstTeam.points }})</mat-card-title>
      <mat-card-subtitle>Team to score the least, conceives the most and gains least amount of points
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.worstTeamOptions"
                            [initValue]="state.betting?.worstTeam"
                            [key]="'worstTeam'"
                            [multi]="state.isSubmissionMode"
                            [multipleDropdowns]="false">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.groupsWithMostScoredGoals) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Group with most goals ({{ state.config.betsConfig.groupsWithMostScoredGoals.points }})
      </mat-card-title>
      <mat-card-subtitle>Group which scored the most number of gaols in total during the stage</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.groupWithMostScoredGoalsOptions"
                            [initValue]="state.betting?.groupsWithMostScoredGoals"
                            [key]="'groupsWithMostScoredGoals'"
                            [multi]="state.isSubmissionMode"
                            [multipleDropdowns]="false">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.groupsWithLeastScoredGoals) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Group with least goals ({{ state.config.betsConfig.groupsWithLeastScoredGoals.points }})
      </mat-card-title>
      <mat-card-subtitle>Group which scored the least number of gaols in total during the stage
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.groupWithLeastScoredGoalsOptions"
                            [initValue]="state.betting?.groupsWithLeastScoredGoals"
                            [key]="'groupsWithLeastScoredGoals'"
                            [multi]="state.isSubmissionMode"
                            [multipleDropdowns]="false">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.totalGoals) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Under over ({{ state.config.betsConfig.totalGoals.points }})</mat-card-title>
      <mat-card-subtitle>Total number of goals during the stage</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-button-group-betting [bettingForm]="state.bettingForm"
                               [initValue]="state.betting?.totalGoals"
                               [key]="'totalGoals'"
                               [options]="state.totalGoalsOptions">
      </oo-button-group-betting>
    </mat-card-content>
  </mat-card>
}
